module.exports = __webpack_public_path__ + "img/labelItem2@2x.aac19404.png";